<script setup lang="ts">
import { computed } from 'vue'

import cn from 'internal/tailwind-classmerge'

import {
  type HTMLAttributeClass,
  SliderRange,
  SliderRoot,
  type SliderRootEmits,
  type SliderRootProps,
  SliderThumb,
  SliderTrack,
  useForwardPropsEmits,
} from '@fond-of/fondof-ui'

const props = defineProps<SliderRootProps & HTMLAttributeClass>()
const emits = defineEmits<SliderRootEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <SliderRoot
    :class="
      cn(
        'relative mt-4 flex w-full touch-none select-none items-center',
        props.class
      )
    "
    v-bind="forwarded"
  >
    <SliderTrack
      class="bg-gray-medium relative size-0.5 w-full grow cursor-pointer rounded-full"
    >
      <SliderRange class="bg-primary absolute h-full" />
    </SliderTrack>
    <SliderThumb
      v-for="(_, key) in modelValue"
      :key="key"
      class="border-primary bg-primary-light block size-6 cursor-pointer rounded-full border-2 disabled:pointer-events-none disabled:opacity-50"
    />
  </SliderRoot>
</template>
